export const inDoor = {
  type: 'In Door',
  arType: 'أبواب داخلية',
  assets: [
    {
      id: 1,
      img: 'https://storage.googleapis.com/door-assets/site/indoor/in_door_19_web.jpg',
      title: '',
    },
    {
      id: 2,
      img: 'https://storage.googleapis.com/door-assets/site/indoor/in_door_50_web.jpg',
      title: '',
    },
    {
      id: 3,
      img: 'https://storage.googleapis.com/door-assets/site/indoor/in_door_T_1_web.jpg',
      title: '',
    },
    {
      id: 4,
      img: 'https://storage.googleapis.com/door-assets/site/indoor/in_door_T_2_web.jpg',
      title: '',
    },
    {
      id: 5,
      img: 'https://storage.googleapis.com/door-assets/site/indoor/in_door_T_3_web.jpg',
      title: '',
    },
  ]
};